/**
 * We don't want to import whole lodash, and we don't want to have any dependencies at all. Here we copy pieces of lodash when we need them

 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
export function clamp(number, lower, upper) {
    number = number <= upper ? number : upper;
    number = number >= lower ? number : lower;
    return number;
}
